import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AxiosInstance } from 'axios';
import { ConfigurationService } from '@/config/configuration-service';

export const getUser = async () => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();

  const userUri = `${poApiUri}/Users`;
  const response = await axiosInstance.get(userUri);

  return response.data;
}
